"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Footer_1 = __importDefault(require("./Footer/Footer"));
exports.Footer = Footer_1.default;
var DynamicTable_1 = __importDefault(require("./DynamicTable/DynamicTable"));
exports.DynamicTable = DynamicTable_1.default;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy9iZWxsdXMvT3B0T3V0cy9Db21tb25TZWN0aW9ucy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUFBLDJEQUFvQztBQUU1QixpQkFGRCxnQkFBTSxDQUVDO0FBRGQsNkVBQXNEO0FBQ3RDLHVCQURULHNCQUFZLENBQ1MifQ==